<script>
import NavBar from "@/components/NavBar";
import FooterBar from "@/components/FooterBar";

export default {
  components: {
    NavBar,
    FooterBar
  }
};
</script>

<template>
  <div id="wrapper">
    <div id="body">
      
    <NavBar />
    <main>
      <slot />
    </main>
    <FooterBar />
    </div>
  </div>
</template>

<style lang="scss" scoped>
#body {
  max-width: 1200px;
  margin: auto;
}

</style>
